import { Inject } from "@angular/core";
import {
    extendMapTools,
    MapTools,
    OlOverlayComponent,
    TrvInteractions,
    TrvMap,
    TrvNgMapOverlayService,
    TrvNgMapService,
    getExtentFromCoordinates,
    LayerListItem,
    PinBlueInfoStyle
} from "@trafikverket/trv-ng-map";

import { Collection, Feature, MapBrowserEvent } from "ol";
import { LineString, MultiLineString, MultiPoint, Point, Polygon } from "ol/geom";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import ImageWMS from "ol/source/ImageWMS";
import { Icon, Text, Style, Fill, Stroke, RegularShape } from "ol/style";
import { Coordinate, add } from "ol/coordinate";
import { Draw, Modify, Select, Snap, Translate } from "ol/interaction";
import { DrawEvent } from "ol/interaction/Draw";
import { TranslateEvent } from "ol/interaction/Translate";
import { Pixel } from "ol/pixel";
import { Extent, getCenter, getTopLeft } from "ol/extent";
import { environment } from "src/environments/environment";
import { NetDbService } from "../service/net-db.service";
import { buffer as extentBuffer } from "ol/extent";
import { fromExtent } from "ol/geom/Polygon";
import { layer } from "@fortawesome/fontawesome-svg-core";
import CircleStyle from "ol/style/Circle";
import { finalize, firstValueFrom, fromEvent, Subject, take, takeUntil } from "rxjs";
import { TrvMapExtensionService } from "../service/trv-map-extension.service";
import { ROUTES } from "@angular/router";
import { NavigationState, NvdbNavigationService } from "../service/nvdb-navigation.service";
import { TrvGlobalMessagesService, TrvModalService } from "@trv-hub/trv-ng-common";
import { ModifyEvent } from "ol/interaction/Modify";
import BaseEvent from "ol/events/Event";
import { DateTime } from "luxon";
import { faL } from "@fortawesome/free-solid-svg-icons";
import Geometry from "ol/geom/Geometry";
import { set } from "ol/transform";
import TileWMS from "ol/source/TileWMS";
import GeoJSON from "ol/format/GeoJSON";
import { get as getProjection, transform } from "ol/proj";
import { LoadingSpinnerComponent } from "@components/utils/loading-spinner/loading-spinner.component";
import { FOCUSED, HIDDEN, REPORT_ITEM_ID } from "@shared/constants";
import { GeometryType } from "@shared/enums";
import { ApmService } from "@app/service/apm.service";
import { FeatureTypeRequest, FeatureTypeRequestMultiple } from "@app/_api/njdbpawebb/models";

export class TrvMapExtension {
    public tempLayer?: VectorLayer<VectorSource>;
    public pinLayer?: VectorLayer<VectorSource>;
    public reportLayer!: VectorLayer<VectorSource>;
    public infoClickTempLayer!: VectorLayer<VectorSource>;
    public infoClickBgTempLayer!: VectorLayer<VectorSource>;

    public pointDraw!: Draw;
    public isDrawingPoint: boolean = false;

    public lineDraw!: Draw;
    public isDrawingLine: boolean = false;
    public numberOfLinesCurrentlyGettingDrawn: number = 0;

    public polygonDraw!: Draw;
    public isDrawingPolygon: boolean = false;

    public reportModify!: Modify;
    public reportTranslate!: Translate;
    public isTranslating: boolean = false;

    public reportTranslateFeaturesCollection = new Collection<Feature<Geometry>>();

    //Info
    public hasSearchedForInfoObjects = false;

    public currentInfoObjects: any[] = [];
    public currentInfoObject: number = 0;
    public currentInfoObjectsChanged: Subject<void> = new Subject<void>();

    public currentInfoObjectsMultiple: any = {};
    public currentInfoLoading: boolean = false;

    public currentDataSlagLayer!: LayerListItem;

    public currentInfoClickName = "";
    public currentInfoClickMetaKey = "";
    public infoClickMetaKeys: string[] = [];
    public currentInfoclickDate = new Date();
    private unsubscribeInfoClick$ = new Subject<void>();
    public lastInfoClickCoordinate: Coordinate = [0, 0];
    public lastInfoClickExtent: Extent = [];
    public lastInfoClickWasInCoord: boolean = false;
    public showBackToInfoClickInCoord: boolean = false;

    public currentBetraktelsedatum: DateTime = DateTime.now();

    public InfoMarkerStyle2 = new Style({
        image: new Icon({
            anchor: [0.5, 0.9],
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            scale: 0.4,
            src: "assets/images/pins/pin_blue_info.svg",
        }),
    });

    public InfoMarkerStyle = [
        new Style({
            image: new Icon({
                anchor: [0.5, 0.9],
                anchorXUnits: "fraction",
                anchorYUnits: "fraction",
                scale: 0.75,
                src: "assets/images/pins/pin_blue_info.svg",
            }),
        }),
        new Style({
            image: new Icon({
                anchor: [0.50, 0.4],
                anchorXUnits: "fraction",
                anchorYUnits: "fraction",
                scale: 0.75,
                src: "assets/img/pin_background.png",
            }),
        }),
    ];

    public infoClickFeatureStyle = [
        new Style({
            stroke: new Stroke({
                color: "rgba(0,255,255, 0.4)",
                width: 18,
            }),

            image: new CircleStyle({
                radius: 16,
                stroke: new Stroke({
                    color: "rgba(0,255,255, 0.4)",
                    width: 7,
                }),
            }),
        }),
    ];

    public infoClickFeatureStyle2 = [
        new Style({
            fill: new Fill({
                color: "rgba(0,0,128, 0.5)",
            }),
            stroke: new Stroke({
                color: "rgba(0,0,128, 0.5)",
                width: 8,
            }),

            image: new CircleStyle({
                radius: 16,
                stroke: new Stroke({
                    color: "rgba(0, 0, 128, 0.5)",
                    width: 3,
                }),
            }),
        }),
        new Style({
            image: new Icon({
                anchor: [0.5, 0.9],
                anchorXUnits: "fraction",
                anchorYUnits: "fraction",
                scale: 0.75,
                src: "assets/images/pins/pin_blue_info.svg",
            }),
        }),
        new Style({
            image: new Icon({
                anchor: [0.5, 0.4],
                anchorXUnits: "fraction",
                anchorYUnits: "fraction",
                scale: 0.75,
                src: "assets/img/pin_background.png",
            }),
        }),
        
    ];

    public lineDrawStyle = new Style({
        stroke: new Stroke({
            color: "red",
            width: 3,
        }),
    });

    public lineDrawHoverStyle = new Style({
        stroke: new Stroke({
            color: "rgba(30, 92, 136, 1)",
            width: 6,
        }),
    });

    public polygonDrawStyle = new Style({
        fill: new Fill({
            color: "rgba(215, 0, 0, 0.2)",
        }),
        stroke: new Stroke({
            color: "rgba(215, 0, 0, 0.7)",
            width: 3,
        }),
    });

    public polygonDrawHoverStyle = new Style({
        fill: new Fill({
            color: "rgba(30, 92, 136, 0.4)",
        }),
        stroke: new Stroke({
            color: "rgba(30, 92, 136, 1)",
            width: 6,
        }),
    });

    public infoClickMouseStyle = new Style({
        image: new Icon({
            anchor: [-1, -0.5],
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            scale: 0.5,
            src: "assets/images/misc/info.png",
        }),
        text: new Text({
            font: "17px Calibri,sans-serif",
            fill: new Fill({ color: "#000" }),
            text: "Info",
            stroke: new Stroke({
                color: "#fff",
                width: 2,
            }),
            offsetY: 18,
            offsetX: 40,

            textAlign: "left",
        }),
    });

    public removeReportMouseStyle = new Style({
        image: new Icon({
            anchor: [-1, 0.5],
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            scale: 1,
            src: "assets/img/bin.png",
        }),
        text: new Text({
            font: "17px Calibri,sans-serif",
            fill: new Fill({ color: "#000" }),
            text: "",
            stroke: new Stroke({
                color: "#fff",
                width: 2,
            }),
            offsetY: 3,
            offsetX: 40,

            textAlign: "left",
        }),
    });

    public editReportMouseStyle = new Style({
        image: new Icon({
            anchor: [-1, 0.5],
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            scale: 1,
            src: "assets/img/edit.png",
        }),
    });

    constructor(
        @Inject(TrvNgMapService) private trvMapService: TrvNgMapService,
        @Inject(TrvNgMapOverlayService) private trvMapOverlayService: TrvNgMapOverlayService,
        @Inject(NvdbNavigationService) private nvdbNavigation: NvdbNavigationService,
        @Inject(NetDbService) private netDbService: NetDbService,
        @Inject(TrvMapExtensionService) private trvMapExtensionService: TrvMapExtensionService,
        @Inject(TrvGlobalMessagesService) public globalMessagesService: TrvGlobalMessagesService,
        @Inject(TrvModalService) public trvModalService: TrvModalService,
        @Inject(ApmService) public apmService: ApmService
    ) {
        this.init();
    }

    public init() {

        //Add layers
        this.tempLayer = new VectorLayer({
            source: new VectorSource({}),
        });

        this.pinLayer = new VectorLayer({
            source: new VectorSource({}),
        });

        this.reportLayer = new VectorLayer({
            source: new VectorSource({}),
        });

        this.infoClickBgTempLayer = new VectorLayer({
            source: new VectorSource({}),
        });

        this.infoClickTempLayer = new VectorLayer({
            source: new VectorSource({}),
        });

        this.trvMapService.trvMap?.trvLayer.addLayer(this.pinLayer);
        this.trvMapService.trvMap?.trvLayer.addLayer(this.reportLayer);
        this.trvMapService.trvMap?.trvLayer.addLayer(this.infoClickBgTempLayer);
        this.trvMapService.trvMap?.trvLayer.addLayer(this.infoClickTempLayer);
        this.trvMapService.trvMap?.trvLayer.addLayer(this.tempLayer, true);

        const trvInteractions: TrvInteractions = this.trvMapService.trvMap!.trvInteractions;
        trvInteractions.simpleRulerTool = false;

        extendMapTools("InfoClick");

        trvInteractions.registerMapToolInteraction({
            mapTool: MapTools.InfoClick,
            initFunc: this.infoClickReset.bind(this),
            resetFunc: this.infoClickReset.bind(this),
            clickFunc: this.infoClick.bind(this),
            moveFunc: this.infoMove.bind(this),
        });

        //Interactions for dataleverans only

        this.trvMapExtensionService.initEmitter.emit();
    }

   

    public infoClickReset(trvMap: TrvMap) {
        this.infoClickBgTempLayer?.getSource()?.clear();
        this.infoClickTempLayer?.getSource()?.clear();
        this.tempLayer?.getSource()?.clear();
    }

    public infoClick(evt: MapBrowserEvent<any>, trvMap: TrvMap) {
        const clickedCoordinate = trvMap.map.getCoordinateFromPixel(evt.pixel);

        this.lastInfoClickCoordinate = clickedCoordinate;
        this.hasSearchedForInfoObjects = true;
        this.nvdbNavigation.navigationState = NavigationState.InfoClick;
        this.nvdbNavigation.navigationStateChanged.emit();

        const pixelBuffer = 6; // Pixels around coordinate to info click with

        //const clickedCoordinate = trvMap.map.getCoordinateFromPixel(evt.pixel);
        const resolution = trvMap.map.getView().getResolution();
        const mapBuffer = pixelBuffer * resolution!;

        const extent: Extent = [
            clickedCoordinate[0] - mapBuffer,
            clickedCoordinate[1] - mapBuffer,
            clickedCoordinate[0] + mapBuffer,
            clickedCoordinate[1] + mapBuffer,
        ];

        this.lastInfoClickExtent = extent;

        this.infoClicked(extent, trvMap);
    }

    public infoClicked(extent: Extent, trvMap: TrvMap) {

        this.currentInfoLoading = true;
        const extentGeometry = fromExtent(extent);
        const feature = new Feature(extentGeometry);
        this.infoClickBgTempLayer.getSource()?.clear();
        this.infoClickTempLayer.getSource()?.clear();



        const infoMarker = new Feature(new Point(getCenter(extent)));
        infoMarker.setStyle(this.InfoMarkerStyle);

        trvMap.trvLayer.addFeature(infoMarker, this.infoClickTempLayer);


        //Get active layers that has trv:metaKey
        let dataslagLayers = trvMap.trvLayer.wmsLayerListItems!;
        dataslagLayers = dataslagLayers.filter((layer: { active: any; trvData: { hasOwnProperty: (arg0: string) => any } }) => {
            return layer.active && layer.trvData.hasOwnProperty("metaKey");
        });

        if (this.currentInfoLoading) {
            this.cancelInfoClickSubscription();
            this.currentInfoLoading = true;
        }

        if (dataslagLayers.length == 0) {
            this.currentInfoObjectsMultiple = {};
            this.currentInfoObjects = [];
            this.currentInfoObject = 0;
            this.currentInfoObjectsChanged.next();
            //Search in point
            var infoClickInCoordinateObj: FeatureTypeRequest = {
                metaKey: "",
                extent: extent,
                viewDate: this.currentBetraktelsedatum.toISO(),
            };

            this.apmService.renameCurrentTransaction("InfoClick - in coordinate");

            this.netDbService
                .infoClickInCoordinate(infoClickInCoordinateObj)
                .pipe(take(1), takeUntil(this.unsubscribeInfoClick$))
                .pipe(
                    finalize(() => {
                        this.currentInfoLoading = false;
                    })
                )
                .subscribe({
                    next: (dataTables: string) => {
                        this.showBackToInfoClickInCoord = false;
                        this.lastInfoClickWasInCoord = true;

                        let dataObjects = JSON.parse(dataTables);
                        if (dataObjects.length == 0) return;
                        let keys = ["VeryUniqueKey:Utvalda värden i aktuell punkt"];
                        this.infoClickMetaKeys = keys;
                        this.currentInfoObjectsMultiple = { "VeryUniqueKey:Utvalda värden i aktuell punkt": dataObjects };
                        var firstKey = keys[0];
                        this.changeInfoObject(firstKey);
                    },
                    error: e => {
                    },
                    complete: () => {},
                    
                });
            return;
        }

        let metaKey: string = "";
        let metaKeys: string[] = [];
        if (dataslagLayers[0].trvData.hasOwnProperty("metaKey")) metaKey = (dataslagLayers[0].trvData as any).metaKey;

        if (metaKey.length == 0) {
            this.currentInfoObjectsMultiple = {};
            this.currentInfoObjects = [];
            this.currentInfoObjectsChanged.next();
            this.currentInfoObject = 0;
            this.currentInfoLoading = false;
            return;
        }

        dataslagLayers.forEach((dataslagLayer: { trvData: { hasOwnProperty: (arg0: string) => any } }) => {
            if (dataslagLayer.trvData.hasOwnProperty("metaKey")) metaKeys.push((dataslagLayer.trvData as any).metaKey);
        });

        
        if(environment.application === 'JNBKarta'){
            // Special case for JNB karta where we need to add year to meta keys
            let currentYear = this.nvdbNavigation.searchMenuState.yearObject.value;
            if(currentYear){
                
                metaKeys = metaKeys.map(key => `${key}${currentYear.displayYear}`);
            }
            
        }

        var objMultiple: FeatureTypeRequestMultiple = {
            metaKeys: metaKeys,
            extent: extent,
            viewDate: this.currentBetraktelsedatum.toISO(),
        };

        this.apmService.renameCurrentTransaction("InfoClick - on layers");

        this.netDbService
            .infoClickMultiple(objMultiple)
            .pipe(take(1), takeUntil(this.unsubscribeInfoClick$))
            .pipe(
                finalize(() => {
                    this.currentInfoLoading = false;
                })
            )
            .subscribe({
                next: (dataTables: string) => {
                    this.showBackToInfoClickInCoord = this.lastInfoClickWasInCoord;
                    this.lastInfoClickWasInCoord = false;

                    let dataObjects = JSON.parse(dataTables);

                    let keys = Object.keys(dataObjects);
                    this.infoClickMetaKeys = keys;
                    this.currentInfoObjectsMultiple = dataObjects;
                    if (keys.length == 0) {
                        this.currentInfoObjects = [];
                        this.currentInfoObjectsChanged.next();
                        this.currentInfoObject = 0;
                        return;
                    }

                    var firstKey = keys[0];
                    this.changeInfoObject(firstKey);
                },
                error: e => {},
                complete: () => {},
            });
    }

    public changeInfoObject(metaKey: string) {
        const trvMap = this.trvMapService.getTrvMap()!;

        if (!this.currentInfoObjectsMultiple.hasOwnProperty(metaKey)) {
            console.error("Couldn't find meta key");
            return;
        }

        const firstValue = this.currentInfoObjectsMultiple[metaKey];

        if (Array.isArray(firstValue)) {
            this.currentInfoObjects = firstValue;
            this.currentInfoObjectsChanged.next();
            this.currentInfoObject = 0;

            this.currentInfoClickName = this.getLayerNameFromMetakey(metaKey);
            this.currentInfoClickMetaKey = metaKey;

            if (metaKey != "VeryUniqueKey:Utvalda värden i aktuell punkt") {

                if(environment.application === 'JNBKarta'){
                    metaKey = this.stripYearFromMetaKey(metaKey);
                }

                this.currentDataSlagLayer = trvMap.trvLayer.wmsLayerListItems.find(
                    (layer: LayerListItem) => layer.trvData.hasOwnProperty("metaKey") && (layer.trvData as any).metaKey == metaKey
                )!;
                if (!this.currentDataSlagLayer) throw Error("Måste hitta ett valid dataslag");
            }
            this.setCurrentInfoObject(this.currentInfoObject, this.trvMapService.trvMap!);
        }
    }

    public getLayerNameFromMetakey(metaKey: string) {
        if (metaKey == "VeryUniqueKey:Utvalda värden i aktuell punkt") return "Utvalda värden i aktuell punkt";
        
        if(environment.application === 'JNBKarta'){
            metaKey = this.stripYearFromMetaKey(metaKey);
            
        }

        var foundLayer = this.trvMapService.trvMap!.trvLayer.wmsLayerListItems.find(
            a => this.trvMapService.trvMap!.trvLayer.getLayerData(a, "metaKey") == metaKey
        )

        if(!foundLayer){
            console.error("Couldn't find layer for metakey:", metaKey);
            return "Kunde inte hitta lagernamn";
        }

        return foundLayer.name;
    }

    public stripYearFromMetaKey(metaKey: string) {
        //If it ends in :year remove it, match with regex. must be 4 digits in end and :

        const regex = /(.*):\d{4}$/;
        const match = metaKey.match(regex);
        if(match){
            metaKey = match[1] + ":";
        }
        return metaKey;
    }

    public setCurrentInfoObject(index: number, trvMap: TrvMap) {
        if (index >= 0 && index < this.currentInfoObjects.length) {
            this.currentInfoObject = index;
            this.currentInfoObjectsChanged.next();
            let infoObj = this.currentInfoObjects[index];
            if (infoObj.hasOwnProperty("WKT")) {
                try {
                    this.infoClickBgTempLayer.getSource()?.clear();
                    this.infoClickTempLayer.getSource()?.clear();

                    let infoClickResultGeometries = JSON.parse(infoObj.WKT);
                    let wktString = infoClickResultGeometries.Geom;

                    if (infoClickResultGeometries.BackGeoms.length == 0) {
                        var feature = trvMap.trvLayer.getFeatureFromWkt(wktString);
                        feature.setStyle(this.infoClickFeatureStyle);

                        trvMap.trvLayer.addFeature(feature, this.infoClickTempLayer);
                    } else {
                        infoClickResultGeometries.BackGeoms.forEach((_wkt: string) => {
                            var feature = trvMap.trvLayer.getFeatureFromWkt(_wkt);
                            feature.setStyle(this.infoClickFeatureStyle);
                            trvMap.trvLayer.addFeature(feature, this.infoClickBgTempLayer);
                        });
                    }

                    var feature2 = trvMap.trvLayer.getFeatureFromWkt(wktString);
                    feature2.setStyle(this.infoClickFeatureStyle2);

                    trvMap.trvLayer.addFeature(feature2, this.infoClickTempLayer);

                    if (infoClickResultGeometries.HasDirection) {
                        var dir = infoClickResultGeometries.Direction;

                        var geom = feature2.getGeometry();
                        if (geom instanceof LineString) {
                            const coords = geom.getCoordinates();
                            if (coords.length > 2) {
                                let lastIndex = coords.length - 1;
                                var rotation = 0;

                                var lastCoord = coords[lastIndex];
                                var nextLastCoord = coords[lastIndex - 1];

                                if (dir == "2") {
                                    lastCoord = coords[0];
                                    nextLastCoord = coords[1];
                                }

                                var arrowPoint = new Point(lastCoord);
                                var arrowFeature = new Feature(arrowPoint);

                                var x1: number = lastCoord[0];
                                var y1: number = lastCoord[1];

                                var x2: number = nextLastCoord[0];
                                var y2: number = nextLastCoord[1];

                                const dx = x1 - x2;
                                const dy = y1 - y2;

                                rotation = Math.atan2(dy, dx) * -1 + Math.PI / 2;

                                const arrowSymbol = new Icon({
                                    anchor: [0.5, 0.4], // Center of the icon
                                    anchorXUnits: "fraction",
                                    anchorYUnits: "fraction",
                                    src: "assets/img/info-arrow.png", // Path to your custom arrow image
                                    rotation: rotation,
                                });

                                const infoClickArrowStyle = new Style({
                                    image: arrowSymbol,
                                });

                                arrowFeature.setStyle(infoClickArrowStyle);
                                trvMap.trvLayer.addFeature(arrowFeature, this.infoClickTempLayer);
                            }
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        } else {
            console.error("Tried to set an info object that doesn't exists");
        }
    }

    public infoMove(evt: MapBrowserEvent<any>, trvMap: TrvMap) {
        const pixel = trvMap.map.getEventPixel(evt.originalEvent);

        this.tempLayer?.getSource()?.clear();

        const point = new Point(evt.coordinate);
        const feature = new Feature(point);
        feature.setStyle(this.infoClickMouseStyle);

        this.tempLayer?.getSource()?.addFeature(feature);
    }

    public loadingLineSnapToGridStyle = new Style({
        stroke: new Stroke({
            color: "rgba(255,0,0,0.3)",
            width: 3,
        }),
    });

    public cancelInfoClickSubscription() {
        this.unsubscribeInfoClick$.next();
    }
}

export var SearchStyle = new Style({
    stroke: new Stroke({
        color: "#1e5c88",
        width: 6,
        lineDash: [0.5, 10],
    }),
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_search.svg",
    }),
});